import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { LojaIntegradaCompletionMessages } from "@/messages/platforms/lojaIntegradaConnection/lojaIntegrada-completion.messages";

interface Props {
  messages: LojaIntegradaCompletionMessages;
}

export function LojaIntegradaCompletion({ messages }: Props) {
  return (
    <MDBox>
      <MDBox width="82%" textAlign="left" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="body2" color="text">
            {messages.lojaIntegradaCompletionMessagesText1Part1}
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          {messages.lojaIntegradaCompletionMessagesText1Part2}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}
